import { UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent } from '@faststore/sdk/dist/analytics/sendAnalyticsEvent'
import { LEVELS } from './constants'
import type {
  MenuItem,
  MenuState,
  NextLevel,
  NextLevelItem,
} from './global-navigation'

export const addMenuItemsIndex = (menuItems: MenuItem[]) => {
  return menuItems.map((element, index: number) => ({
    ...element,
    index: index,
  }))
}

export const getMenuSections = (globalNavigation: MenuItem[]) => {
  return addMenuItemsIndex(globalNavigation).reduce(
    (acc: Array<MenuItem[]>, val: MenuItem) => {
      val.separator === false || val.separator === null
        ? acc[acc.length - 1].push(val)
        : acc[acc.length - 1].push(val) && acc.push([])
      return acc
    },
    [[]]
  )
}

export const getSubHeaderMenu = (globalNavigation: MenuItem[]) => {
  const processedSubheadeMenu = addMenuItemsIndex(globalNavigation).reduce(
    (acc: MenuItem[], val: MenuItem) => {
      if (
        (val.subHeaderPosition && val.subHeaderPosition !== null) ||
        val.subHeaderPosition === undefined
      )
        acc.push(val)
      return acc
    },
    []
  )

  return processedSubheadeMenu.sort((a, b) => {
    if (!a.subHeaderPosition || !b.subHeaderPosition) {
      return 0
    }
    return a.subHeaderPosition > b.subHeaderPosition ? 1 : -1
  })
}

// const hasToSelectAnimal = (item: any) => {
//   return item?.nextLevel?.accordionMenu
// }

// export const processMenuType = (menu: any) => {
//   return menu.reduce(
//     (acc: any, val: any) => {
//       if (val.nextLevel.title !== null)
//         acc[hasToSelectAnimal(val) ? 'accordionMenu' : 'animalListMenu']?.push(
//           val
//         )
//       return acc
//     },
//     {
//       animalListMenu: [],
//       accordionMenu: [],
//     }
//   )
// }

export const getAlphabeticalMenuItems = (menu: NextLevel) => {
  return menu.items?.reduce(
    (
      acc: Record<string, { label: string | null; url: string | null }[]>,
      curr: NextLevelItem
    ) => {
      let firstLetter = curr?.label?.[0]

      if (!acc[firstLetter ?? '']) {
        acc[firstLetter ?? ''] = []
      }

      acc[firstLetter ?? ''].push({ label: curr.label, url: curr.labelURL })

      return acc
    },
    {}
  )
}

export const getItemsFilteredBySearch = (
  key: string,
  values: string,
  input: string
): Record<string, { label: string | null; url: string | null }[]> => {
  return values === ''
    ? {}
    : {
        [key]: JSON.parse(values)?.filter(
          (el: { label: string | null; url: string | null }) =>
            el?.label?.toLowerCase()?.startsWith(input)
        ),
      }
}

export const getSearchedItems = (input: string, menu: NextLevel) => {
  const key = input?.toUpperCase()?.charAt(0)
  const { [key]: _ } = getAlphabeticalMenuItems(menu)
  const values = _ != undefined ? JSON.stringify(_) : ''
  return input === ''
    ? getAlphabeticalMenuItems(menu)
    : getItemsFilteredBySearch(key, values, input)
}

export const getMenuDesktopTracking = (level: number, state: MenuState) => {
  let result: string = ''
  let main_category: string = ''

  // if (level === LEVELS.main) {
  //   result = `${state?.firstLevelItem?.label}`
  // }

  if (level === LEVELS.second_level) {
    result = `${state?.secondLevelItem?.label}`
  }

  if (level === LEVELS.third_level) {
    result = `${state?.secondLevelItem?.label}||${state?.thirdLevelItem?.label}`
  }

  if (level === LEVELS.fourth_level) {
    result = `${state?.secondLevelItem?.label}||${state?.thirdLevelItem?.label}||${state?.fourthLevelItem?.label}`
  }

  main_category = `${state?.firstLevelItem?.label}`

  return { result, main_category }
}

export const getMenuMobileTracking = (
  state: MenuState,
  label: string | null
) => {
  let result: string = ''
  let main_category: string = ''

  // if (state.selectedLevel === LEVELS.main) {
  //   result = `${label}`
  // }

  if (state.selectedLevel === LEVELS.second_level) {
    result = `${label}`
  }

  if (state.selectedLevel === LEVELS.third_level) {
    result = `${state?.secondLevelItem?.label}||${label}`
  }

  if (state.selectedLevel === LEVELS.fourth_level) {
    result = `${state?.secondLevelItem?.label}||${state?.thirdLevelItem?.label}||${label}`
  }

  main_category = `${state?.firstLevelItem?.label ?? label}`

  return { result, main_category }
}

export const trackMenuPath = (state: MenuState, label: string | null) => {
  const data = getMenuMobileTracking(state, label)
  if (!data.main_category) return

  sendAnalyticsEvent<UnknownEvent>({
    name: 'menu_categorie',
    params: {
      path: data.result,
      section: 'hamb_menu',
      main_category: data.main_category,
    },
  })
}

export const trackMenuPathDesktop = (level: number, state: MenuState) => {
  const data = getMenuDesktopTracking(level, state)
  if (!data.main_category) return

  sendAnalyticsEvent<UnknownEvent>({
    name: 'menu_categorie',
    params: {
      path: data.result,
      section: 'hamb_menu',
      main_category: data.main_category,
    },
  })
}

export const isItemInPath = (
  state: MenuState,
  itemLevel: number | undefined,
  position: number | undefined
) => {
  if (position === undefined || itemLevel === undefined) return false

  let result: boolean = false
  switch (itemLevel) {
    case 1:
      result = state?.firstLevelItem?.index === position
      break
    case 2:
      result = state?.secondLevelItem?.index === position
      break
    case 3:
      result = state?.thirdLevelItem?.index === position
      break
    case 4:
      result = state?.fourthLevelItem?.index === position
      break
    default:
      break
  }

  return result
}

export const hasNextLevel = (item: NextLevelItem | MenuItem) => {
  return (
    item?.nextLevel?.items !== null &&
    item?.nextLevel?.items !== undefined &&
    item?.nextLevel?.items?.length > 0
  )
}
